
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33895',
  depVersions: {
  "documents-public-ui": "static-1.33895",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33900",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1894",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5361",
  "hs-test-utils": "static-1.7775",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11189",
  "I18n": "static-7.1562",
  "jasmine-immutable": "static-1.2788",
  "jasmine-runner": "static-1.6242",
  "lodash": "static-1.3",
  "quartz": "static-1.6686",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16411",
  "reporting-data": "static-1.66388",
  "reporting-testing-lib": "static-1.8321",
  "reporting-visualizations": "static-1.58464",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4535",
  "webpack-env": "static-1.54",
  "atom": "static-1.4840",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2255",
  "classnames": "static-2.10",
  "cssUtils": "static-1.724",
  "customer-data-filters-ui": "static-1.38776",
  "customer-data-objects": "static-1.7413",
  "customer-data-property-utils": "static-1.7841",
  "data-fetching-client": "static-1.9447",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4299",
  "flux-actions": "static-1.304",
  "FormsCommonComponents": "static-1.85204",
  "FormUrlGenerator": "static-2.4500",
  "foundations-components": "static-1.7464",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11497",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6932",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3629",
  "property-translator": "static-1.5183",
  "quartz-config": "static-1.464",
  "quartz-core": "static-1.5905",
  "quick-fetch": "static-1.3705",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5145",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7930",
  "reference-resolvers-lite": "static-1.7860",
  "report-customization-components": "static-1.12416",
  "reporting-enablement": "static-1.21968",
  "reporting-reports": "static-1.66066",
  "reporting-snowflake": "static-1.55006",
  "reporting-ui-components": "static-2.63659",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4402",
  "sales-content-partitioning": "static-1.8705",
  "SalesContentIndexUI": "static-3.8855",
  "sanitize": "static-1.4244",
  "sanitize-text": "static-1.7910",
  "self-service-api": "static-1.10006",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1524",
  "signup-constants": "static-1.18330",
  "signup-ui-lego-core": "static-1.20340",
  "signup-ui-url-generator": "static-2.7834",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4541",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10764",
  "ui-addon-i18n": "static-1.10902",
  "ui-addon-react-router-dom": "static-1.9317",
  "ui-addon-upgrades": "static-9.17604",
  "ui-asset-management-lib": "static-1.10668",
  "ui-images": "static-2.1084",
  "UIComponents": "static-3.8136",
  "usage-tracker": "static-1.7102",
  "usage-tracker-container": "static-1.7092",
  "usage-tracker-core": "static-1.6952",
  "usage-tracker-public": "static-1.6913",
  "viral-links-lib": "static-1.6799",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3200",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2963",
  "quartz-webpack": "static-1.2910",
  "ai-components-ui-library": "static-1.8267",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4603",
  "foundations-theming": "static-1.4178",
  "quartz-auth": "static-1.361",
  "usage-tracker-session-replay": "static-1.4788",
  "foundations-theming-base": "static-1.3163",
  "HeadJS": "static-2.704",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2886",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4099",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7694",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3477",
  "reporting-client-types": "static-1.2379",
  "hs-story-utils": "static-1.9198",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9404",
  "hubspotter-http": "static-1.4449",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7019",
  "crm-message-bus": "static-1.42259",
  "customer-data-filters-ui-msw-helpers": "static-1.21210",
  "customer-data-objects-ui-components": "static-1.12774",
  "customer-data-reference-ui-components": "static-1.12913",
  "customer-data-ui-utilities": "static-1.9594",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6545",
  "framework-data-schema-resolvers": "static-1.6640",
  "inbound-db-properties-service-client": "static-1.3647",
  "multi-account-reference-resolvers": "static-1.739",
  "onboarding-tours": "static-1.16216",
  "reporting-datasets-permissions-lib": "static-1.12966",
  "ui-addon-teams": "static-1.21198",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67534",
  "customer-data-properties": "static-1.50702",
  "forms-ai-lib": "static-1.3968",
  "forms-utils-lib": "static-1.12113",
  "foundations-components-test-utils": "static-1.4947",
  "react-dnd-compat": "static-1.4392",
  "react-tinymce": "static-1.54538",
  "tinymce-config": "static-2.53664",
  "ui-gdpr-components": "static-1.10117",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3733",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1110",
  "ui-fonts": "static-1.451",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.787",
  "mobile-manifest-mixins": "static-1.477",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.351",
  "quartz-i18n": "static-1.361",
  "quartz-routing": "static-1.116",
  "quartz-test": "static-1.361",
  "batch-promise": "static-1.1320",
  "external-options-client-types": "static-1.3956",
  "react-colorpicker": "static-2.9981",
  "copilot-toolkit": "static-1.10445",
  "data-quality-ui-library": "static-1.12249",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40577",
  "reporting-insights-lib": "static-1.1071",
  "reporting-plugins": "static-1.9943",
  "ui-addon-draggable-compat": "static-2.4023",
  "ui-addon-opt": "static-4.8155",
  "ui-shepherd-react": "static-3.9914",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24637",
  "hubspot-apollo-client": "static-1.4649",
  "sales-templates-service-types-lib": "static-1.3966",
  "ui-business-units-lib": "static-1.8793",
  "merchandise-lib": "static-1.257",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5442",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3876",
  "upgrade-management-service-types": "static-1.4278",
  "timezone-utils": "static-2.5014",
  "bender-build-tools": "static-1.2903",
  "chatspot-core": "static-1.20190",
  "chirp-fetch": "static-1.1654",
  "bend-plugin-foundations-theming": "static-1.2661",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9402",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3596",
  "crm-pipelines-api-client-types": "static-1.3936",
  "multi-currency-client-types": "static-1.3490",
  "getting-started-shared-tasks": "static-1.17793",
  "growth-data-modal": "static-1.5121",
  "growth-onboarding-confetti": "static-1.2840",
  "growth-onboarding-next-action-utils": "static-1.1265",
  "navigation-components": "static-1.17169",
  "onboarding-tours-client": "static-1.4430",
  "onboarding-tours-utils": "static-1.282",
  "ui-shepherd-tracker": "static-1.7295",
  "ui-universal-auth": "static-1.8650",
  "user-context": "static-1.4864",
  "cms-field-types": "static-1.4575",
  "content-icons-ui": "static-1.2145",
  "integrations-lib": "static-1.15317",
  "calling-global-api": "static-1.63551",
  "calling-internal-common": "static-1.31062",
  "calling-lifecycle-internal": "static-1.64933",
  "calling-lifecycle-messages": "static-1.57227",
  "commerce-products-lib": "static-1.8765",
  "crm-links": "static-1.6025",
  "file-manager-components": "static-1.22798",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.443",
  "inbounddb-objects-service-types": "static-1.4022",
  "meetings-icalendar-utils-lib": "static-1.403",
  "object-builder-ui-client": "static-1.47868",
  "pipeline-validation-client-types": "static-1.3758",
  "property-value-citations": "static-1.1316",
  "pulse": "static-1.274",
  "smart-property-lib": "static-1.5764",
  "tiered-pricing": "static-1.783",
  "ui-addon-iframeable": "static-1.8811",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19422",
  "tinymce-themes": "static-1.55634",
  "data-token-picker": "static-1.15994",
  "hub-http-contrib": "static-1.2814",
  "interframe": "static-3.4561",
  "tinymce-data": "static-1.39749",
  "tinymce-plugins": "static-1.56778",
  "ui-addon-sales-email": "static-1.4983",
  "magpie-lib": "static-1.5364",
  "magpie-types": "static-1.4824",
  "simple-logging-lib": "static-1.2820",
  "content-assistance-lib": "static-1.7405",
  "dashboard-lib": "static-1.80493",
  "ExportDialog": "static-6.10158",
  "hubspot-prosemirror": "static-1.17517",
  "hubspot-prosemirror-plugins": "static-1.17509",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8461",
  "campaign-roi-lib": "static-1.8182",
  "feedback-loader": "static-1.28796",
  "onboarding-scopes": "static-1.6233",
  "apollo-link-hub-http": "static-2.4418",
  "hubspot-apollo-cache": "static-1.108",
  "growth-monetization-service-types": "static-1.4294",
  "nav-client-types": "static-1.2126",
  "purchase-motions-api": "static-1.5445",
  "trials-service-types": "static-1.3695",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.496",
  "unified-auth-core-lib": "static-1.445",
  "getting-started-shared-tasks-store": "static-1.16911",
  "integrations-error-boundary-lib": "static-1.12732",
  "integrations-tracking-lib": "static-1.5354",
  "native-integrations-shared-strings": "static-1.7558",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10142",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31068",
  "shared-worker-versioning": "static-1.10806",
  "calling-usage-tracker": "static-1.6308",
  "voice-sms-access-library": "static-1.153",
  "customer-data-tracking": "static-1.6651",
  "products-iframe-lib": "static-1.7233",
  "products-ui-components-shared-msw-handlers": "static-1.9786",
  "location-customization-utils-lib": "static-1.8459",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3924",
  "video-components-external": "static-1.10483",
  "video-data-lib": "static-1.34141",
  "directed-graph": "static-1.707",
  "event-emitter": "static-1.717",
  "breeze-intelligence-kit": "static-1.5277",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9487",
  "fsm": "static-1.3501",
  "policy-lib": "static-1.6554",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9550",
  "navigation-messaging": "static-1.6496",
  "FileManagerLib": "static-1.38438",
  "NamespacedHubStyle": "static-2.8869",
  "FileManagerCore": "static-1.38297",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.11978",
  "layout-dnd-utils": "static-1.10953",
  "react-codemirror": "static-1.10396",
  "ui-addon-emoji-picker": "static-1.9658",
  "ui-brand-identity-lib": "static-1.13725",
  "ui-addon-video-player": "static-1.8466",
  "ui-coaching-tips": "static-1.27863",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8339",
  "payment-link-components": "static-1.22854",
  "EmailSignatureEditor": "static-1.23859",
  "eligibility-engine-service-types": "static-1.2976",
  "universal-page-editor-lib": "static-1.2766",
  "calling-orchestration-schema": "static-1.34930",
  "sales-views-client-types": "static-1.4062",
  "crm-record-cards-service-types": "static-1.3424",
  "content-media-composition-data-lib": "static-1.11341",
  "content-media-compositions": "static-2.15348",
  "media-bridge-lib": "static-1.18516",
  "trellis-story-utils": "static-1.4293",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5569",
  "FileManagerImages": "static-1.35949",
  "video-components": "static-1.12486",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4304",
  "video-embed": "static-1.34975",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67609",
  "layout-data-lib": "static-1.9278",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6355",
  "commerce-tours-lib": "static-1.5672",
  "growth-onboarding-reliability": "static-1.4858",
  "sales-checkout-service-client": "static-1.3448",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21260",
  "sales-email-signature-service-client": "static-1.3615",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21265",
  "outpost": "static-1.3976",
  "advanced-menus-core": "static-1.14772",
  "advanced-menus-lib": "static-1.11754",
  "ui-memberships-settings-lib": "static-1.33347",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14771",
  "simple-menus-lib": "static-1.16288"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33895",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33900",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1894",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5361",
  "hs-test-utils": "/hs-test-utils/static-1.7775",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11189",
  "I18n": "/I18n/static-7.1562",
  "jasmine-immutable": "/jasmine-immutable/static-1.2788",
  "jasmine-runner": "/jasmine-runner/static-1.6242",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6686",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16411",
  "reporting-data": "/reporting-data/static-1.66388",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8321",
  "reporting-visualizations": "/reporting-visualizations/static-1.58464",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4535",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4840",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2255",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.724",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38776",
  "customer-data-objects": "/customer-data-objects/static-1.7413",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7841",
  "data-fetching-client": "/data-fetching-client/static-1.9447",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4299",
  "flux-actions": "/flux-actions/static-1.304",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85204",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4500",
  "foundations-components": "/foundations-components/static-1.7464",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11497",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6932",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3629",
  "property-translator": "/property-translator/static-1.5183",
  "quartz-config": "/quartz-config/static-1.464",
  "quartz-core": "/quartz-core/static-1.5905",
  "quick-fetch": "/quick-fetch/static-1.3705",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5145",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7930",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7860",
  "report-customization-components": "/report-customization-components/static-1.12416",
  "reporting-enablement": "/reporting-enablement/static-1.21968",
  "reporting-reports": "/reporting-reports/static-1.66066",
  "reporting-snowflake": "/reporting-snowflake/static-1.55006",
  "reporting-ui-components": "/reporting-ui-components/static-2.63659",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4402",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8705",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8855",
  "sanitize": "/sanitize/static-1.4244",
  "sanitize-text": "/sanitize-text/static-1.7910",
  "self-service-api": "/self-service-api/static-1.10006",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1524",
  "signup-constants": "/signup-constants/static-1.18330",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20340",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7834",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4541",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10764",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10902",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9317",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17604",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10668",
  "ui-images": "/ui-images/static-2.1084",
  "UIComponents": "/UIComponents/static-3.8136",
  "usage-tracker": "/usage-tracker/static-1.7102",
  "usage-tracker-container": "/usage-tracker-container/static-1.7092",
  "usage-tracker-core": "/usage-tracker-core/static-1.6952",
  "usage-tracker-public": "/usage-tracker-public/static-1.6913",
  "viral-links-lib": "/viral-links-lib/static-1.6799",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3200",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2963",
  "quartz-webpack": "/quartz-webpack/static-1.2910",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8267",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4603",
  "foundations-theming": "/foundations-theming/static-1.4178",
  "quartz-auth": "/quartz-auth/static-1.361",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4788",
  "foundations-theming-base": "/foundations-theming-base/static-1.3163",
  "HeadJS": "/HeadJS/static-2.704",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2886",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4099",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7694",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3477",
  "reporting-client-types": "/reporting-client-types/static-1.2379",
  "hs-story-utils": "/hs-story-utils/static-1.9198",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9404",
  "hubspotter-http": "/hubspotter-http/static-1.4449",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7019",
  "crm-message-bus": "/crm-message-bus/static-1.42259",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21210",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12774",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12913",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9594",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6545",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6640",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3647",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.739",
  "onboarding-tours": "/onboarding-tours/static-1.16216",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12966",
  "ui-addon-teams": "/ui-addon-teams/static-1.21198",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67534",
  "customer-data-properties": "/customer-data-properties/static-1.50702",
  "forms-ai-lib": "/forms-ai-lib/static-1.3968",
  "forms-utils-lib": "/forms-utils-lib/static-1.12113",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4947",
  "react-dnd-compat": "/react-dnd-compat/static-1.4392",
  "react-tinymce": "/react-tinymce/static-1.54538",
  "tinymce-config": "/tinymce-config/static-2.53664",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10117",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3733",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1110",
  "ui-fonts": "/ui-fonts/static-1.451",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.787",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.351",
  "quartz-i18n": "/quartz-i18n/static-1.361",
  "quartz-routing": "/quartz-routing/static-1.116",
  "quartz-test": "/quartz-test/static-1.361",
  "batch-promise": "/batch-promise/static-1.1320",
  "external-options-client-types": "/external-options-client-types/static-1.3956",
  "react-colorpicker": "/react-colorpicker/static-2.9981",
  "copilot-toolkit": "/copilot-toolkit/static-1.10445",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12249",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40577",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1071",
  "reporting-plugins": "/reporting-plugins/static-1.9943",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4023",
  "ui-addon-opt": "/ui-addon-opt/static-4.8155",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9914",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24637",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4649",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3966",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8793",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5442",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3876",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4278",
  "timezone-utils": "/timezone-utils/static-2.5014",
  "bender-build-tools": "/bender-build-tools/static-1.2903",
  "chatspot-core": "/chatspot-core/static-1.20190",
  "chirp-fetch": "/chirp-fetch/static-1.1654",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2661",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9402",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3596",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3936",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3490",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17793",
  "growth-data-modal": "/growth-data-modal/static-1.5121",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2840",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1265",
  "navigation-components": "/navigation-components/static-1.17169",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4430",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.282",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7295",
  "ui-universal-auth": "/ui-universal-auth/static-1.8650",
  "user-context": "/user-context/static-1.4864",
  "cms-field-types": "/cms-field-types/static-1.4575",
  "content-icons-ui": "/content-icons-ui/static-1.2145",
  "integrations-lib": "/integrations-lib/static-1.15317",
  "calling-global-api": "/calling-global-api/static-1.63551",
  "calling-internal-common": "/calling-internal-common/static-1.31062",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64933",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57227",
  "commerce-products-lib": "/commerce-products-lib/static-1.8765",
  "crm-links": "/crm-links/static-1.6025",
  "file-manager-components": "/file-manager-components/static-1.22798",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.443",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4022",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.403",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47868",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3758",
  "property-value-citations": "/property-value-citations/static-1.1316",
  "pulse": "/pulse/static-1.274",
  "smart-property-lib": "/smart-property-lib/static-1.5764",
  "tiered-pricing": "/tiered-pricing/static-1.783",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8811",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19422",
  "tinymce-themes": "/tinymce-themes/static-1.55634",
  "data-token-picker": "/data-token-picker/static-1.15994",
  "hub-http-contrib": "/hub-http-contrib/static-1.2814",
  "interframe": "/interframe/static-3.4561",
  "tinymce-data": "/tinymce-data/static-1.39749",
  "tinymce-plugins": "/tinymce-plugins/static-1.56778",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4983",
  "magpie-lib": "/magpie-lib/static-1.5364",
  "magpie-types": "/magpie-types/static-1.4824",
  "simple-logging-lib": "/simple-logging-lib/static-1.2820",
  "content-assistance-lib": "/content-assistance-lib/static-1.7405",
  "dashboard-lib": "/dashboard-lib/static-1.80493",
  "ExportDialog": "/ExportDialog/static-6.10158",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17517",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17509",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8461",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8182",
  "feedback-loader": "/feedback-loader/static-1.28796",
  "onboarding-scopes": "/onboarding-scopes/static-1.6233",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4418",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.108",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4294",
  "nav-client-types": "/nav-client-types/static-1.2126",
  "purchase-motions-api": "/purchase-motions-api/static-1.5445",
  "trials-service-types": "/trials-service-types/static-1.3695",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.496",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.445",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16911",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12732",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5354",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7558",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10142",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31068",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10806",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6308",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.153",
  "customer-data-tracking": "/customer-data-tracking/static-1.6651",
  "products-iframe-lib": "/products-iframe-lib/static-1.7233",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9786",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8459",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3924",
  "video-components-external": "/video-components-external/static-1.10483",
  "video-data-lib": "/video-data-lib/static-1.34141",
  "directed-graph": "/directed-graph/static-1.707",
  "event-emitter": "/event-emitter/static-1.717",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5277",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9487",
  "fsm": "/fsm/static-1.3501",
  "policy-lib": "/policy-lib/static-1.6554",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9550",
  "navigation-messaging": "/navigation-messaging/static-1.6496",
  "FileManagerLib": "/FileManagerLib/static-1.38438",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8869",
  "FileManagerCore": "/FileManagerCore/static-1.38297",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.11978",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10953",
  "react-codemirror": "/react-codemirror/static-1.10396",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9658",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13725",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8466",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27863",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8339",
  "payment-link-components": "/payment-link-components/static-1.22854",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2976",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2766",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34930",
  "sales-views-client-types": "/sales-views-client-types/static-1.4062",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3424",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11341",
  "content-media-compositions": "/content-media-compositions/static-2.15348",
  "media-bridge-lib": "/media-bridge-lib/static-1.18516",
  "trellis-story-utils": "/trellis-story-utils/static-1.4293",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5569",
  "FileManagerImages": "/FileManagerImages/static-1.35949",
  "video-components": "/video-components/static-1.12486",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4304",
  "video-embed": "/video-embed/static-1.34975",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67609",
  "layout-data-lib": "/layout-data-lib/static-1.9278",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6355",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5672",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4858",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3448",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21260",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3615",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "outpost": "/outpost/static-1.3976",
  "advanced-menus-core": "/advanced-menus-core/static-1.14772",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11754",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33347",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14771",
  "simple-menus-lib": "/simple-menus-lib/static-1.16288"
}
};
